import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import LoginFormLayout from './layout';
import { validateFields } from '../../../utility/validation';
import http, {
  AUTH,
  ACCESS_TOKEN,
  TOKEN_TYPE,
  TWO_FACTOR_AUTH,
} from '../../../utility/http';
import {
  API_2FA_INITIATE,
  API_LOGIN,
  API_ME,
} from '../../../constants/apiRoutes';
import StorageService from '../../../utility/storageService';
import fields from './fields';

const LoginForm = withFormik({
  mapPropsToValues: () => ({
    email: '',
    password: '',
  }),
  validate: async values => {
    throw await validateFields(fields, values);
  },
  enableReinitialize: true,
  validateOnBlur: false,
  handleSubmit: (values, { props, setSubmitting, setErrors }) => {
    http
      .post(API_LOGIN, values)
      .then(response => {
        const twoFactorAuth = JSON.parse(StorageService.get(TWO_FACTOR_AUTH));

        const initiate2FA = response.data?.initiate_2fa;

        if (response.data.otp_required || initiate2FA) {
          if (initiate2FA) {
            http.defaults.headers.Authorization = `${TOKEN_TYPE} ${response.data[ACCESS_TOKEN]}`;
            http.post(API_2FA_INITIATE).then(({ data }) => {
              StorageService.set(
                TWO_FACTOR_AUTH,
                JSON.stringify({
                  ...twoFactorAuth,
                  initiate2FA,
                  accessToken: response.data[ACCESS_TOKEN],
                  email: values.email,
                  QRSecret: data.secret,
                })
              );
              setSubmitting(false);
              props.navigate('/login/authentication');
            });
          } else {
            StorageService.set(
              TWO_FACTOR_AUTH,
              JSON.stringify({
                ...twoFactorAuth,
                initiate2FA,
                accessToken: response.data[ACCESS_TOKEN],
                email: values.email,
              })
            );
            setSubmitting(false);
            props.navigate('/login/authentication');
          }
        } else {
          http.defaults.headers.Authorization = `${TOKEN_TYPE} ${response.data[ACCESS_TOKEN]}`;

          // fetch user by token
          Promise.all([
            http.get(API_ME),
            props.getAuthPermissions(),
            props.getOrganizationSettings(),
            props.getOrganizationMenuSetup(),
            props.getAllPresets(),
          ]).then(([user]) => {
            const authInfo = {
              ...response.data,
              ...user.data,
            };
            props.setAuthInfo(authInfo);
            StorageService.set(AUTH, JSON.stringify(authInfo));
            setSubmitting(false);
            StorageService.remove(TWO_FACTOR_AUTH);
            props.navigate(props.redirectUrl);
          });
        }
      })
      .catch(error => {
        const status = error?.response?.status;
        if (status === 400) {
          setErrors({ error: 'noActiveAccount' });
        }
        if (status === 429) {
          setErrors({ error: 'rateLimit' });
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  },
})(LoginFormLayout);

LoginForm.propTypes = {
  setAuthInfo: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
};

export default LoginForm;
